import React from 'react'
import GameHomepage from '../GameHomepage'
import Ad from '../Ad'

const Games = () => {
    return (
        <div>

            <GameHomepage />

            <Ad />

        </div>
    )
}

export default Games